import { render, staticRenderFns } from "./comments-response.vue?vue&type=template&id=b8c73f68&"
import script from "./comments-response.vue?vue&type=script&lang=ts&"
export * from "./comments-response.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports